// 接口域名地址
let baseURL,
  lawURL,
  protocol = 'https://',
  hostName = '',
  lawName = '',
  searchCaseUrl = '',
  legalAdviceUrl = ''

// https://lawsearch-sy-pre.odrcloud.cn  开发和测试
// https://lawsearch-sy.odrcloud.cn  生产
if (process.env.NODE_ENV === 'development') {
  // hostName = 'devhnswodr.odrcloud.cn'
  // lawName = 'lawsearch-sy-pre.odrcloud.cn'
  // searchCaseUrl = 'testhnswkb-retrieval.odrcloud.cn'
  // legalAdviceUrl = 'testkb-retrieval.odrcloud.cn/#/'

  hostName = 'devhnswodr.odrcloud.cn'
  lawName = 'lawsearch-sy.odrcloud.cn'
  legalAdviceUrl = 'kb-retrieval.odrcloud.cn/#/'
  //
  // hostName = 'hnodr.hainan.gov.cn'
  // lawName = 'lawsearch-sy.odrcloud.cn'
  // hostName = 'http://182.254.208.106:8113'
} else if (process.env.NODE_ENV === 'production') {
  if (process.env.srconfig === 'test') {
    hostName = 'testhnswodr.odrcloud.cn'
    lawName = 'lawsearch-sy-pre.odrcloud.cn'
    legalAdviceUrl = 'testkb-retrieval.odrcloud.cn/#/'
  } else if (process.env.srconfig === 'dev') {
    hostName = 'devhnswodr.odrcloud.cn'
    lawName = 'lawsearch-sy-pre.odrcloud.cn'
    legalAdviceUrl = 'testkb-retrieval.odrcloud.cn/#/'
  } else if (process.env.srconfig === 'perform') {
    hostName = 'hnodr.hainan.gov.cn'
    lawName = 'lawsearch-sy.odrcloud.cn'
    legalAdviceUrl = 'testkb-retrieval.odrcloud.cn/#/'
  } else {
    hostName = 'hnodr.hainan.gov.cn'
    lawName = 'lawsearch-sy.odrcloud.cn'
    legalAdviceUrl = 'kb-retrieval.odrcloud.cn/#/'
  }
}
baseURL = protocol + hostName
lawURL = protocol + lawName
legalAdviceUrl = protocol + legalAdviceUrl
export default {
  baseURL: baseURL,
  hostName: hostName,
  lawName: lawName,
  lawURL: lawURL,
  searchCaseUrl: searchCaseUrl,
  legalAdviceUrl: legalAdviceUrl,
  appName: 'hnswodr'
}



// WEBPACK FOOTER //
// ./src/publicResource/config/config.js